module.exports = __webpack_public_path__ + "img/promise.4a84432d.png";